<template>
    <div class="validate-content" :class="{'bodyfont-unauth': !user}">
        <div class="col-md-12">
            <div class="main-content">
                <h2 class="heading">
                    <i class="fa fa-2x fa-check" v-if="validationSuccess"></i>
                    <i class="fa fa-2x fa-times"  v-if="error.show"></i>
                    <br />
                    Account Validation
                </h2>
            </div>
        </div>
        <div v-if="validationSuccess">
            <strong>Thank You! Your Account has been validated</strong>
            <h3 class="redirectMsg" v-if="!user">Log In to TONE Networks!</h3>
            <div class="clearfix"></div>
            <h3 class="text-center">
                <i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i>
                Redirecting now
                <i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i><i class="fa fa-chevron-right "></i>
            </h3>
        </div>
        <div v-if="error.show">
            <strong>Sorry! Your Account could not be validated</strong>
            <h5>{{error.message}}</h5>
        </div>
        <!--<alert v-model="validationSuccess" placement="top-right" duration="2000" type="success" width="400px" dismissable>-->
            <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
            <!--<strong>Thank You! Your Account has been validated</strong>-->
            <!--<p id="validation_successmsg">Now login to Tone Networks to watch our awesome videos</p>-->
        <!--</alert>-->
        <!--<div class="form">-->
            <!--<form v-on:submit.prevent="onSubmit">-->
                <!--<div class="validateField">-->
                    <!--<bs-input v-model="user.email"-->
                              <!--id = "validate_email"-->
                              <!--type="email"-->
                              <!--class="form-input"-->
                              <!--error="Email is Required"-->
                              <!--placeholder="Email Address"-->
                              <!--required-->
                              <!--icon>-->
                    <!--</bs-input>-->
                    <!--<bs-input v-model="user.validationCode"-->
                              <!--id = "validate_validationcode"-->
                              <!--type="text"-->
                              <!--class="form-input"-->
                              <!--error="Code is Required"-->
                              <!--placeholder="Validation Code"-->
                              <!--required-->
                              <!--icon>-->
                    <!--</bs-input>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<button class="btn formButton" id="validate_button">-->
                        <!--Submit-->
                        <!--&lt;!&ndash;<spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>&ndash;&gt;-->
                    <!--</button>-->
                <!--</div>-->
            <!--</form>-->
            <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                <!--<strong>Error:</strong>-->
                <!--<p id="login_errormsg">{{error.message}}</p>-->
            <!--</alert>-->
        <!--</div>-->
    </div>
</template>

<script>
import { input, alert, spinner } from 'vue-strap'
import { mapGetters } from 'vuex'
import store from '../store'
var crypto = require('crypto')

export default {
    components: {
        'bs-input': input,
        alert,
        spinner
    },
    name: 'validate',
    data: function () {
        return {
            userObj: {
                email: '',
                code: '',
                validationCode: ''
            },
            spinner: false,
            paramEmail: '',
            paramValidationCode: '',
            validationSuccess: false
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user', 'getValidationStatusError'
        ])
    },
    methods: {
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        onSubmit: function () {
            if (this.user) {
                // this.spinnerToggle()
                this.$store.dispatch('VALIDATE', {user: this.user}).then(() => {
                   //  this.spinnerToggle()
                    if (!this.error.show) {
                        this.validationSuccess = true
                        setTimeout(() => {
                            this.validationSuccess = false
                            this.$router.push('/')
                        }, 4000)
                    }
                })
            }
        }
    },
    mounted: function () {
        let self = this
        // User is confired and tries to hit the link again
        if (self.user && (this.user.status.toLowerCase() === 'confirm' || self.user.status.toLowerCase() === 'confirmed')) {
            setTimeout(() => {
                self.$swal({
                    title: 'Your account has already been validated',
                    text: '',
                    type: 'info',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(
                    function () {
                    },
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    }
                )
            }, 500)
            self.$router.push('/mytone')
        } else if (self.user && (self.user.status.toLowerCase() === 'register' || self.user.status.toLowerCase() === 'registered')) { // User is logged-in but status is not confirmed
            if (self.$route.query.params) {
                // slice the params
                let encryptedEmail = self.$route.query.params.substr(0, self.$route.query.params.indexOf('^'))
                let validationCode = self.$route.query.params.substr(self.$route.query.params.indexOf('^') + 1)
                // Decrypt the email
                let decipher = crypto.createDecipher('aes-256-cbc', 'tonenetworks')
                let decrypted = decipher.update(encryptedEmail, 'hex', 'utf-8')
                decrypted = decrypted + decipher.final('utf-8')
                self.userObj.email = decrypted
                self.userObj.validationCode = validationCode
                if (self.userObj.email.length > 0 && self.userObj.validationCode.length > 0) {
                    // this.spinnerToggle()
                    self.$store.dispatch('VALIDATE', {user: self.userObj}).then(() => {
                        // this.spinnerToggle()
                        if (!self.error.show) {
                            self.validationSuccess = true
                            setTimeout(() => {
                                let logUserTemp = sessionStorage.getItem('loggedUserTemp')
                                if (logUserTemp) {
                                    logUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'))
                                    logUserTemp.status = 'CONFIRMED'
                                    self.user.status = 'CONFIRMED'
                                    sessionStorage.setItem('loggedUserTemp', JSON.stringify(logUserTemp))
                                }
                                let logUser = localStorage.getItem('loggedUser')
                                if (logUser) {
                                    logUser = JSON.parse(localStorage.getItem('loggedUser'))
                                    logUser.status = 'CONFIRMED'
                                    self.user.status = 'CONFIRMED'
                                    localStorage.setItem('loggedUser', JSON.stringify(logUser))
                                }
                                self.validationSuccess = false
                                self.$router.push('/mytone')
                            }, 4000)
                        } else {
                            self.$swal({
                                title: 'Validation Email has Expired!',
                                text: 'This validation email has expired. Do you want to resend the email?',
                                type: 'error',
                                showCancelButton: true,
                                confirmButtonText: 'Yes, Please',
                                cancelButtonText: 'Cancel',
                                confirmButtonClass: 'btn btn-success',
                                cancelButtonClass: 'btn btn-danger',
                                buttonsStyling: false
                            }).then(function (result) {
                                self.$store.dispatch('RESENDVALIDATIONCODE', encryptedEmail).then(() => {
                                    self.$swal({
                                        title: 'Check your mailbox for new validation email',
                                        text: '',
                                        type: 'success',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(
                                        function () {
                                        },
                                        // handling the promise rejection
                                        function (dismiss) {
                                            if (dismiss === 'timer') {
                                            }
                                        }
                                    )
                                })
                                setTimeout(() => {
                                    self.$router.push('/mytone')
                                }, 4000)
                            })
                        }
                    })
                } else {
                    self.$router.push('/mytone')
                }
            }
        } else { // user is logged-out and tries to hit the link
            if (self.$route.query.params) {
                // slice the params
                let encryptedEmail = self.$route.query.params.substr(0, self.$route.query.params.indexOf('^'))
                let validationCode = self.$route.query.params.substr(self.$route.query.params.indexOf('^') + 1)
                // Decrypt the email
                let decipher = crypto.createDecipher('aes-256-cbc', 'tonenetworks')
                let decrypted = decipher.update(encryptedEmail, 'hex', 'utf-8')
                decrypted = decrypted + decipher.final('utf-8')
                self.userObj.email = decrypted
                self.userObj.validationCode = validationCode
                if (self.userObj.email.length > 0 && self.userObj.validationCode.length > 0 && !self.getValidationStatusError) {
                    self.$store.dispatch('VERIFYUSERSTATUS', self.userObj.email).then(() => {
                        if (!self.getValidationStatusError) {
                            // this.spinnerToggle()
                            self.$store.dispatch('VALIDATE', {user: self.userObj}).then(() => {
                                // this.spinnerToggle()
                                if (!self.error.show) {
                                    self.validationSuccess = true
                                    setTimeout(() => {
                                        self.validationSuccess = false
                                        self.$router.push('/')
                                        store.commit('setTriggerLogin', {loginStatus: true})
                                    }, 4000)
                                } else {
                                    self.$swal({
                                        title: 'Validation Email has Expired!',
                                        text: 'This validation email has expired. Do you want to resend the email?',
                                        type: 'error',
                                        showCancelButton: true,
                                        confirmButtonText: 'Yes, Please',
                                        cancelButtonText: 'Cancel',
                                        confirmButtonClass: 'btn btn-success',
                                        cancelButtonClass: 'btn btn-danger',
                                        buttonsStyling: false
                                    }).then(function (result) {
                                        self.$store.dispatch('RESENDVALIDATIONCODE', self.userObj.email).then(() => {
                                            self.$router.push('/')
                                            self.$swal({
                                                title: 'Check your mailbox for new validation email',
                                                text: '',
                                                type: 'success',
                                                timer: 3000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(
                                                function () {
                                                },
                                                // handling the promise rejection
                                                function (dismiss) {
                                                    if (dismiss === 'timer') {
                                                        self.$router.push('/')
                                                    }
                                                }
                                            )
                                        })
                                    }, function (dismiss) {
                                        self.$router.push('/')
                                    })
                                }
                            })
                        } else {
                            // Account is already validated
                            self.$swal({
                                title: 'Your account has already been validated',
                                text: '',
                                type: 'info',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                        self.$router.push('/')
                                    }
                                }
                            )
                        }
                    })
                }
            } else {
                self.$router.push('/')
            }
        }
            // Validate if coming from Link
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .validate .form{
        text-align: left;
        width: 40%;
        margin: 50px auto;
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .validate h1{
        font-size: 32px;
        color: #009cf6;
        font-weight: lighter;
        margin: 0 0 25px 0;
    }
    .validate p{
        font-size: 14px;
        color: #979797;
        margin: 0;
    }
    .padding-minus{
        padding:0;
    }
    .validate .form .form-input{
        margin-bottom: 25px ;
    }
    .validate .form .forgotPassword{
        float: right;
        color: black
    }
    .validate .form .forgotPassword:hover{
        float: right;
        color: #337ab7;
    }
    .formButton{
        margin: 25px 0 50px;
        width: 130px;
        height: 47px;
        color: #91ab45;
        border-color: #91ab45;
        background-color: transparent;
        transition: 0.5s;
        padding:0;
    }
    .formButton a{
        display: block;
        padding: 13px 12px;
        color: #91ab45;
        text-decoration: none;
        transition: 0.5s;
    }
    .formButton:hover{
        border-color: #91ab45;
        background-color: #91ab45;
        transition: 0.5s;
        color: #ffffff;
    }
    .btn-spinner{
        bottom:15px
    }
</style>



// WEBPACK FOOTER //
// Validate.vue?0da3e566